// import React from "react";
// import { Image } from "@heroui/image";
// import { Icon } from "@iconify/react";

// import { Img30, TextStrip3 } from "@/public/assets";
// import { StarIcon, JobAlert, FindTalent, ApplyForJob } from "@/components";

// const RecruitingHero = () => {
//     return (
//         <section className="max-w-screen-2xl mx-auto lg:px-28 px-6 pt-24 pb-10">
//             <div className="grid grid-cols-2 items-center">
//                 <div>
//                     <div className="inline-flex items-center gap-2 px-3 py-1 rounded-2xl bg-primary-100 dark:bg-primary-50 text-primary-700  mb-6 text-sm leading-5 font-normal tracking-[-0.084px]">
//                         <StarIcon className=" w-4 " />
//                         Trusted by different companies and businesses across the globe
//                     </div>

//                     <div className=" text-[56px] text-black dark:text-foreground-950 leading-[64px] tracking-[-0.56px] font-medium mb-2">
//                         Finding the
//                         <span className="italic text-primary relative whitespace-nowrap">
//                             right talent
//                             <div className="absolute -bottom-1 inset-x-0">
//                                 <Image
//                                     disableSkeleton
//                                     alt="strip 2 image"
//                                     className="animate__animated animate__flipInX w-full"
//                                     src={TextStrip3.src}
//                                 />
//                             </div>
//                         </span>{" "}
//                         has never been easier.
//                     </div>

//                     <div className="text-foreground-600 dark:text-foreground-600 text-lg font-normal leading-6 tracking-[-0.27px] mb-6 max-w-xl">
//                         Cotton Recruiting helps your companies find, vet, and build talent
//                         that fits your operations, culture, and growth stage.
//                     </div>

//                     <div className="flex items-center gap-3 max-w-xs">
//                         <FindTalent />
//                         <ApplyForJob />
//                     </div>
//                 </div>

//                 <div>
//                     <div className="relative">
//                         <div className="absolute z-20 -left-7 top-1 inline-flex rotate-[-14.478deg] px-[13.481px] py-[8.987px] justify-center items-center gap-[8.987px] text-[#1FC16B] dark:text-primary-400 bg-[#D0FBE9] rounded-[26.962px]">
//                             <Icon icon="ri:alarm-warning-fill" /> New job post alert
//                         </div>

//                         <Image className="h-[537px] object-cover" src={Img30.src} />

//                         <JobAlert className="absolute z-20 bottom-12" />
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default RecruitingHero;

import React from "react";
import { Image } from "@heroui/image";
import { Icon } from "@iconify/react";

import { Img30, TextStrip3 } from "@/public/assets";
import { StarIcon, JobAlert, FindTalent, ApplyForJob } from "@/components";

const RecruitingHero = () => {
  return (
    <section className="max-w-screen-2xl mx-auto lg:px-28 px-4 sm:px-6 pt-16 sm:pt-20 md:pt-24 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10 md:gap-0">
        <div className="text-center md:text-left">
          <div
            className="inline-flex items-center gap-2 px-3 py-1 rounded-2xl bg-primary-100 dark:bg-primary-50 text-primary-700 mb-4 sm:mb-6 text-xs sm:text-sm leading-5 font-normal tracking-[-0.084px]"
            data-aos="fade-up"
          >
            <StarIcon className="w-4" />
            Trusted by different companies and businesses across the globe
          </div>

          <div
            className="text-[32px] sm:text-[42px] md:text-[56px] text-black dark:text-foreground-950 leading-[40px] sm:leading-[52px] md:leading-[64px] tracking-[-0.56px] font-medium mb-2"
            data-aos="fade-up"
          >
            Finding the{" "}
            <span className="italic text-primary relative whitespace-nowrap">
              right talent
              <div className="absolute -bottom-1 inset-x-0">
                <Image
                  disableSkeleton
                  alt="strip 2 image"
                  className="animate__animated animate__flipInX w-full"
                  src={TextStrip3.src}
                />
              </div>
            </span>{" "}
            has never been easier.
          </div>

          <div
            className="text-foreground-600 dark:text-foreground-600 text-sm sm:text-base md:text-lg font-normal leading-5 sm:leading-6 tracking-[-0.27px] mb-6 max-w-xl mx-auto md:mx-0"
            data-aos="fade-up"
          >
            Cotton Recruiting helps your companies find, vet, and build talent
            that fits your operations, culture, and growth stage.
          </div>

          <div
            className="flex flex-col sm:flex-row items-center gap-3 max-w-xs mx-auto md:mx-0"
            data-aos="fade-up"
          >
            <FindTalent />
            <ApplyForJob />
          </div>
        </div>

        <div data-aos="fade-left">
          <div className="relative">
            <div className="absolute z-20 left-0 sm:-left-4 md:-left-7 top-2 sm:top-1 inline-flex rotate-[-14.478deg] px-[10px] sm:px-[13.481px] py-[6px] sm:py-[8.987px] justify-center items-center gap-[6px] sm:gap-[8.987px] text-xs sm:text-sm text-[#1FC16B] dark:text-primary-400 bg-[#D0FBE9] rounded-[20px] sm:rounded-[26.962px]">
              <Icon icon="ri:alarm-warning-fill" /> New job post alert
            </div>

            <Image
              className="h-[300px] sm:h-[420px] md:h-[537px] object-cover w-full"
              src={Img30.src}
            />

            <div>
              <JobAlert className="absolute z-20 bottom-4 sm:bottom-8 md:bottom-12 left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecruitingHero;
